import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import projectImage1 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider.jpg';
import projectImage2 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_6.jpg';
import projectImage7 from '../../../../assets/images/work/hoisting-rigging/H&R_Slider_7.jpg';

import Data_HoistingRigging from './Data_HoistingRigging';

function Work_HoistingRigging() {
    return (
        <>
            <DetailedHeader
                heading="Training High-Risk Skills Without the Risk"
                client="NETCO, NORCAT"
                service="Virtual Reality"
                date="2023"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=ITAigEsvANs"
                images={[
                    {
                        image: projectImage1,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage2,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage3,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage4,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage5,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage6,
                        alt: 'Project Image',
                    },
                    {
                        image: projectImage7,
                        alt: 'Project Image',
                    },
                ]}
            />

            {Data_HoistingRigging.content}
        </>
    );
}

export default Work_HoistingRigging;
